module.exports = __webpack_public_path__ + "static/media/mastrack_logo_new.c95e44f8.svg";